import React, { useEffect } from 'react';
import { useParams, useNavigate } from 'react-router-dom';
import { PageLayout } from '@/components/page-layout';
import { EmailServicePage } from './email-service-page';
import { useLayout } from '@/contexts/layout-context';

type SubTabId = 'email';

export const ConfigurationsPage: React.FC = () => {
  const { tab } = useParams<{ tab?: string }>();
  const navigate = useNavigate();
  const { setBreadcrumbs } = useLayout();

  // Normalize route param ('email' or 'email-service' maps to 'email')
  const activeTab: SubTabId = (tab === 'email-service' || tab === 'email') ? 'email' : 'email';

  useEffect(() => {
    // If on base /m/configurations, automatically redirect to /m/configurations/email
    if (!tab) {
      navigate('/m/configurations/email', { replace: true });
    }
  }, [tab, navigate]);

  useEffect(() => {
    setBreadcrumbs([
      { name: 'Configurations', to: '/m/configurations/email' },
      { name: activeTab === 'email' ? 'Email Service' : 'Configurations' }
    ]);
  }, [activeTab, setBreadcrumbs]);

  return (
    <PageLayout
      title="Configurations"
      description="Manage platform-level service integrations, credentials and configurations."
    >
      <div className="animate-in fade-in duration-300">
        {activeTab === 'email' && <EmailServicePage />}
      </div>
    </PageLayout>
  );
};
